// Toda la página vive dentro de `turbo-frame#content` y cualquier enlace de nuestro dominio
// (megamenú, cuerpo de un post, lo que sea) navega dentro de ese frame. Si la ruta la sirve
// OTRA aplicación bajo rankia.com (p. ej. /mi-ruta-financiera), su respuesta no trae el frame
// y Turbo pinta "Content missing". Aquí se convierte ese caso en una navegación completa a la
// URL final (ya seguidas las redirecciones), sin tener que marcar cada enlace con
// data-turbo="false": los enlaces que pegan los usuarios en sus contenidos no los controlamos.
export function navegarCompletoSiFaltaElFrame(evento, navegar = (url) => window.location.assign(url)) {
  if (evento.target.id !== 'content') return

  evento.preventDefault()
  navegar(evento.detail.response.url)
}
